export default {
  GET_CATEGORIES: 'getCategories',
  GET_RESULTS: 'getResults',
  GET_PAGINATION: 'getPagination',
  GET_FILTER: 'getFilter',
};
